<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">

      <VcModalContainer :showDialog="true"
                        :showCloseButton="true"
                        size="xl"
                        :useOffset="false"
                        :showFooterDivider="false"
                        @onCloseButtonClicked="handleClose">
        <template #content>
          <WorkOrderUpgradePage @close="handleClose"/>
        </template>
      </VcModalContainer>

    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import WorkOrderUpgradePage from "./WorkOrderUpgradePage.vue";

export default {
  name: "WorkOrderUpgradeDialog",
  components: {FullscreenFrontageDialog, WorkOrderUpgradePage},
  methods: {
    handleClose() {
      this.$refs.frontageDialog.handleClose();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
